import React from 'react';
import { Languages } from 'lucide-react';
import { useT } from '../context/LanguageContext';

/* Topbar language switch: a two-state pill (EN | FR) rather than a hidden
   dropdown, because the whole point is that a French-speaking user can find
   it without already reading English. The choice is remembered per browser
   (LanguageContext writes localStorage), so a till set to French stays French.
   Sits beside the theme switch; Settings keeps no duplicate control. */
export default function LanguageQuickSwitch() {
  const { locale, setLocale, locales } = useT();
  const codes = Object.keys(locales);

  return (
    <div
      className="flex items-center rounded-md border border-border overflow-hidden"
      role="group"
      aria-label="Language"
      title="Language / Langue"
    >
      <Languages size={14} className="ml-1.5 mr-0.5 text-muted-foreground shrink-0" aria-hidden="true" />
      {codes.map((code) => {
        const active = code === locale;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLocale(code)}
            aria-pressed={active}
            /* The native name, so the choice reads in the language it selects. */
            title={locales[code].nativeLabel}
            className={`px-2 py-1 text-xs font-semibold transition-colors ${
              active
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
            }`}
          >
            {locales[code].flag}
          </button>
        );
      })}
    </div>
  );
}
